import { render, staticRenderFns } from "./SAPSLayout.vue?vue&type=template&id=4f1ae75c&"
import script from "./SAPSLayout.vue?vue&type=script&lang=js&"
export * from "./SAPSLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports